import React       from "react";
import PropTypes   from "prop-types";
import Translation from "../../../../commons/i18n/Translation";

import SearchTypes from './SearchTypes';
import CollapsibleFilterBox from './CollapsibleFilterBox';
import MobileSearchFilters from './MobileSearchFilters';
import SearchTitle from '../common/SearchTitle';
import SearchPostList from '../common/SearchPostList';

import Svg from "../../../../../svg/Svg";

export default class SearchMobilePage extends React.Component {

    static propTypes = {
        query : PropTypes.string,
        onChangeQuery: PropTypes.func,
        types: PropTypes.array,
        contentTypes: PropTypes.string,
        onChangeContentType: PropTypes.func,
        locality: PropTypes.object,
        searchLocality: PropTypes.func,
        onChangeLocality: PropTypes.func,
        group : PropTypes.object,
        searchGroup: PropTypes.func,
        onChangeGroup: PropTypes.func,
        onSetGroup: PropTypes.func,
        onSetLocality: PropTypes.func,
        eventDate: PropTypes.string,
        onChangeEventDate: PropTypes.func,
        surroundings: PropTypes.string,
        onChangeSurroundings: PropTypes.func,
        currentQueryObject: PropTypes.object,
        results: PropTypes.array,
        resultsLocalities: PropTypes.array,
        resultsGroups: PropTypes.array,
        loading: PropTypes.bool,
        onResetFilters: PropTypes.func,
        language: PropTypes.object,
        onChangeLanguage: PropTypes.func
    };

    render = () => (
        <div className="section">
            <div className="pure-g row--expanded">
                <div className="pure-u-1">
                    <div>
                        <div className="mywort-box  mywort-box--white mywort-box--sm">
                            <div className="mywort-box__body">
                                <div className="u-m-v-b">
                                    <div className="input-lined input-lined--keep-label">
                                        <form onSubmit={(ev) => this.props.onSubmit(ev, this.queryInput)}>
                                            <input
                                                ref={(input) => { this.queryInput = input; }}
                                                type="search"
                                                id="search-field"
                                                value={this.props.query}
                                                onChange={this.props.onChangeQuery}
                                                required/>
                                            <span className="input-lined__bar"></span>
                                            <label className="input-lined__label">{Translation.translate("public.search") + '...'}</label>
                                            <button type="submit" className="input-lined__icon">
                                                <Svg id="search" className="input-lined__icon__svg"/>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SearchTypes
                            types={this.props.types}
                            selected={this.props.contentType}
                            query={this.props.currentQueryObject}
                            className="mywort-section-navigation--compact"
                            itemClassName="mywort-section-navigation__entry--half"
                        />
                    </div>
                    <CollapsibleFilterBox
                        title={Translation.translate("search.filters.title")}
                        expanded={this.props.locality|| this.props.group}
                        className="mywort-collapse--compact mywort-collapse--light u-m-v">
                        <div className="mywort-filters">
                            <MobileSearchFilters
                                comingFrom={this.props.comingFrom}
                                query={this.props.query}
                                onChangeQuery={this.props.onChangeQuery}
                                contentType={this.props.contentType}
                                locality={this.props.locality}
                                searchLocality={this.props.searchLocality}
                                onChangeLocality={this.props.onChangeLocality}
                                group={this.props.group}
                                searchGroup={this.props.searchGroup}
                                onChangeGroup={this.props.onChangeGroup}
                                eventDate={this.props.eventDate}
                                onChangeEventDate={this.props.onChangeEventDate}
                                surroundings={this.props.surroundings}
                                onChangeSurroundings={this.props.onChangeSurroundings}
                                onResetFilters={this.props.onResetFilters}
                                language={this.props.language}
                                onChangeLanguage={this.props.onChangeLanguage}
                            />
                        </div>
                    </CollapsibleFilterBox>
                    <SearchTitle
                        comingFrom={this.props.comingFrom}
                        query={this.props.query}
                    />
                    <section className="mywort-teaser-list">
                        <SearchPostList
                            results={this.props.results}
                            loading={this.props.loading}
                            onResetFilters={this.props.onResetFilters}
                        />
                    </section>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/mobile/SearchMobilePage.jsx